import React, { useState, useContext, forwardRef, useMemo, useRef, useEffect } from 'react';
import { Slider, Button } from 'antd';
import { GenerateContext } from "@utils/GenerateContext"
import { SketchPicker } from 'react-color'
import pen1 from '@assets/images/pen_1.png';
import pen2 from '@assets/images/pen_2.png';
import icon_add from '@assets/images/icon_add.svg';
import icon_remove from '@assets/images/icon_remove.svg';
import styles from './index.module.scss'

const ChangeColorBar = forwardRef((props, ref) => {
    const { eraserSize, operationKey, isDraw, isLoading2, setDrawType, drawType, paintSize, modeState,  aiEditUrl, selectedColor, setSelectedColor } = useContext(GenerateContext)
    const btnPicList = useRef([{
        iconActive: icon_add,
        iconDisabled: icon_add,
        zhtext: '增加选区',
        enText: 'multi_add',
        show: true,
    }, {
        iconActive: icon_remove,
        iconDisabled: icon_remove,
        zhtext: '减少选区',
        enText: 'multi_reduce',
        show: true,
    }, {
        iconActive: pen1,
        iconDisabled: pen2,
        zhtext: '涂抹',
        enText: 'draw',
        show: true
    }])
    const [createNum, setCreateNum] = useState(4)


    const btnDisabled = useMemo(() => {
        return isDraw.length == 0
    }, [isDraw])


    const onCreateNumChange = (val) => {
        if (val == 'add') {
            if (createNum < 10) setCreateNum(pre => pre + 1)
        } else if (val == 'reduce') {
            if (createNum > 1) setCreateNum(pre => pre - 1)
        }
    }

    const sliderDisabled = useMemo(() => {
        return drawType != 'draw'
    }, [drawType])


    return (
        <div className={styles.ChangeColorBar}>
            <div className={styles.edit_center}>
                <p className={styles.topTitle}>换色区域</p>
                <div className={`${styles.magicEraseBar_btn}  ${!aiEditUrl && styles.disabled}`} style={{marginBottom: '10px'}}>
                    {
                        btnPicList.current.filter((item => item.show)).map((item, index) => {
                            return <div
                                key={index}
                                // onClick={() => { if(!aiEditUrl) return; setDrawType(item.enText) }}
                                onClick={() => { setDrawType(item.enText) }}
                                className={`${styles.magicEraseBar_btn_}  ${drawType == item.enText ? styles.magicEraseBar_btn_selected : null}`}>
                                <img src={drawType == item.enText ? item.iconDisabled : item.iconActive} alt="" />
                                <p>{item.zhtext}</p>
                            </div>
                        })
                    }
                </div>
                <p className={styles.title2} >
                    <Button
                        color={modeState == 'eraser' ? 'default' : 'primary'}
                        variant="outlined"
                        size='small'
                        disabled={sliderDisabled}
                        onClick={() => props.repairSizeChange(paintSize, 'paint')}
                        style={{ 
                            padding: '0 8px',
                            height: '24px',
                            fontSize: '12px',
                            lineHeight: '22px',
                            borderColor: modeState == 'paint' && drawType == 'draw'?'#393EFD': null,
                            color: modeState == 'paint' && drawType == 'draw'? '#393EFD': null
                        }}
                    >画笔</Button>
                </p>
                <div className={styles.operation_box} style={{marginBottom: '5px'}}>
                    <Slider
                        value={paintSize}
                        min={1}
                        defaultValue={paintSize}
                        tooltip={{ formatter: null }}
                        onChange={(vale) => props.repairSizeChange(vale, 'paint')}
                        onChangeComplete={(vale) => props.repairSizeChange(vale, 'paint')}
                        disabled={sliderDisabled} />
                    <span className={styles.size}>{paintSize}</span>
                </div>
                <p className={styles.title2}>
                    <Button
                        color={modeState == 'paint' ? 'default' : 'primary'}
                        variant="outlined"
                        size='small'
                        disabled={sliderDisabled}
                        onClick={() => props.repairSizeChange(eraserSize, 'eraser')}
                        style={{
                            padding: '0 8px',
                            height: '24px',
                            fontSize: '12px',
                            lineHeight: '22px',
                            borderColor: modeState == 'eraser'&& drawType == 'draw'?'#393EFD': null,
                            color: modeState == 'eraser'&& drawType == 'draw'? '#393EFD': null
                        }}
                    >橡皮</Button>
                </p>
                <div className={styles.operation_box}>
                    <Slider
                        value={eraserSize}
                        min={1}
                        defaultValue={eraserSize}
                        tooltip={{ formatter: null }}
                        onChange={(vale) => props.repairSizeChange(vale, 'eraser')}
                        onChangeComplete={(vale) => props.repairSizeChange(vale, 'eraser')}
                        disabled={sliderDisabled} />
                    <span className={styles.size}>{eraserSize}</span>
                </div>
                
                <SketchPicker 
                    color={selectedColor}
                    disableAlpha={true}
                    presetColors={[
                        ...JSON.parse(localStorage.getItem('AIEditColorList') || '[]')
                    ]}
                    onChangeComplete={(color) => {
                        setSelectedColor(color.hex);
                    }}
                    className={styles['sketch-picker-override']}
                />

                {/* <div className={styles.create_styl}>
                    <span style={{ marginRight: '4px', fontSize: 12 }}>生成图片数</span>
                    <span className={`${styles.num_btn} ${createNum == 1 && styles.disabled}`} style={{ marginRight: '8px' }} onClick={(e) => onCreateNumChange('reduce')}>-</span>
                    <span style={{ marginRight: '4px' }}>{createNum}</span>
                    <span className={`${styles.num_btn} ${createNum == 10 && styles.disabled}`} style={{ marginRight: '10px' }} onClick={(e) => onCreateNumChange('add')} >+</span>
                    <span style={{ fontSize: 12 }}>张</span>
                </div> */}
                {/* <Button
                    disabled={btnDisabled || operationKey != 'eraser' || taskType}
                    className='operation_btn'
                    type="primary"
                    loading={isLoading2}
                    onClick={() => isDraw.length > 0 && operationKey == 'eraser' ?
                        props.createClick({ selectedColor: selectedColor, createNum: createNum }) : null}
                >
                    应用{taskType ? '（不支持批量任务）' : null}
                </Button> */}
            </div>
        </div>
    )
})

export default ChangeColorBar;
